// extracted by mini-css-extract-plugin
module.exports = {"container":"TopProjects_container__XT7Cu","bannermove":"TopProjects_bannermove__sM813"};